'use client';

import { useEffect } from 'react';
import { type ClientProfilerPageName, registerClientProfilerPage } from '@/src/lib/clientProfiler';

export function ClientProfilerRegistrar({ pageName }: { pageName: ClientProfilerPageName }) {
  useEffect(() => {
    return registerClientProfilerPage(pageName);
  }, [pageName]);

  return null;
}
